import { Injectable } from '@angular/core';
import {
  AddonHookValidationRules,
  ProposalsHooksService,
} from '../proposals-hooks.service';
import {
  ApplicationConfig,
  ApplicationData,
  Partners,
  Proposal,
} from '@lockton-apps/shared/interfaces';
import { FormGroup } from '@angular/forms';
import { RegulatoryProductConfigId } from '@lockton-apps/shared/util/constants';
import { isArray } from 'lodash';

export interface RegulatoryHooksData {}

@Injectable()
export class RegulatoryApplicationHooksService extends ProposalsHooksService<RegulatoryHooksData> {
  override addonHookValidationRules: AddonHookValidationRules = {
    [`${Partners.REGULATORY}-${RegulatoryProductConfigId.FinancialAdvisers}`]: {
      'pension-questionaire': {
        anyOf: [
          'pensionActivities.pensionTransfers.pensionNumbers.providerSwitchesNumber',
          'pensionActivities.pensionTransfers.pensionNumbers.providerSwitchesNumberAverageValue',
          'pensionActivities.pensionTransfers.pensionNumbers.providerSwitchesNumberLargestValue',
          'pensionActivities.pensionTransfers.pensionNumbers.schemeTransfersNumber',
          'pensionActivities.pensionTransfers.pensionNumbers.schemeTransfersAverageValue',
          'pensionActivities.pensionTransfers.pensionNumbers.schemeTransfersLargestValue',
          'pensionActivities.pensionTransfers.pensionNumbers.sippSwitchesNumber',
          'pensionActivities.pensionTransfers.pensionNumbers.sippSwitchesNumberAverageValue',
          'pensionActivities.pensionTransfers.pensionNumbers.sippSwitchesNumberLargestValue',
        ],
      },
      'authorisation-questionaire': {
        anyOf: [
          {
            path: 'staff.appointedRepresentatives.tradingDetails',
            iteratorFn: (value) => isArray(value) && value.length > 0,
          },
        ],
      },
    },
    [`${Partners.REGULATORY}-${RegulatoryProductConfigId.Intermediaries}`]: {
      'authorisation-questionaire': {
        anyOf: [
          {
            path: 'staff.appointedRepresentatives.tradingDetails',
            iteratorFn: (value) => isArray(value) && value.length > 0,
          },
        ],
      },
    },
  };

  async beforeSave(
    data: ApplicationData,
    form: FormGroup,
    proposal: Proposal,
    config: ApplicationConfig
  ): Promise<Proposal> {
    return super.handleDynamicSteps(data, proposal, config);
  }

  async beforeStepSubmit(
    data: ApplicationData,
    form: FormGroup,
    proposal: Proposal,
    config: ApplicationConfig
  ): Promise<Proposal> {
    return super.handleDynamicSteps(data, proposal, config);
  }
}
